var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reload-attempt"},[_c('AxButton',{attrs:{"type":"submit"},on:{"click":_vm.reload}},[_vm._v(" Reload ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }